import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IHedefTipiTanim_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IHedefTipiTanim_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoalTypesHierarchySave: number;
  GoalTypesHierarchySave_dummy: number;
  GoBack: any;
  GoBack_dummy: any;
  GoalTypesById: any[];
  GoalTypesById_dummy: any[];
  msGoalTypesHierarchyByGoalId: any[];
  msGoalTypesHierarchyByGoalId_dummy: any[];
  sbGoalTypesAll: any[];
  sbGoalTypesAll_dummy: any[];
}

export class HedefTipiTanim_ScreenBase extends React.PureComponent<
  IHedefTipiTanim_ScreenProps,
  any
> {
  ml = [
    {
      Id: "f6e17cbf-9877-1e37-1dda-7f0e2f0194a4",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "58f12691-42c0-4569-8d3d-7de148711af0",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "f747b368-1ec3-4cca-99c2-df9dd23a81cf",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 657512, PropertyName: "label", Value: "Kaydet" },
        { Id: 150725, PropertyName: "value", Value: "Hedef Tipi" },
        { Id: 975860, PropertyName: "value", Value: "Hedef Tipi" },
        {
          Id: 975253,
          PropertyName: "placeholder",
          Value: "Hedef tipi adı yazın...",
        },
        { Id: 718826, PropertyName: "value", Value: "Alt Tipler" },
        { Id: 184070, PropertyName: "placeholder", Value: "Alt tip seçin..." },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.hedeftipitanim_975253_value_kuikaTextInputRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoalTypesHierarchySave: 0,
      GoBack: "",
      GoalTypesById: [],
      msGoalTypesHierarchyByGoalId: [],
      sbGoalTypesAll: [],
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("hedeftipitanim", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.HedefTipiTanimPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("hedeftipitanim", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["Admin"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("hedeftipitanim", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.HedefTipiTanimPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      hedeftipitanim_975253_value:
        this.state.GoalTypesById?.at?.(0)?.name ?? undefined,
      hedeftipitanim_184070_value:
        this.state.msGoalTypesHierarchyByGoalId?.at?.(0)?.goalTypes ??
        undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  HedefTipiTanimPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      GoalTypeId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HedefTipiTanim/HedefTipiTanimPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GoalTypesById = result?.data.goalTypesById;
    formVars.hedeftipitanim_975253_value = ReactSystemFunctions.toString(
      this,
      stateVars.GoalTypesById !== undefined
        ? stateVars.GoalTypesById?.length > 0
          ? stateVars.GoalTypesById[0].name
          : null
        : this.state.GoalTypesById?.length > 0
        ? this.state.GoalTypesById[0].name
        : null
    );
    stateVars.msGoalTypesHierarchyByGoalId =
      result?.data.msGoalTypesHierarchyByGoalId;
    formVars.hedeftipitanim_184070_value = ReactSystemFunctions.toString(
      this,
      stateVars.msGoalTypesHierarchyByGoalId !== undefined
        ? stateVars.msGoalTypesHierarchyByGoalId?.length > 0
          ? stateVars.msGoalTypesHierarchyByGoalId[0].goalTypes
          : null
        : this.state.msGoalTypesHierarchyByGoalId?.length > 0
        ? this.state.msGoalTypesHierarchyByGoalId[0].goalTypes
        : null
    );
    formVars.hedeftipitanim_184070_value =
      stateVars.msGoalTypesHierarchyByGoalId !== undefined
        ? stateVars.msGoalTypesHierarchyByGoalId?.length > 0
          ? stateVars.msGoalTypesHierarchyByGoalId[0].goalTypes
          : null
        : this.state.msGoalTypesHierarchyByGoalId?.length > 0
        ? this.state.msGoalTypesHierarchyByGoalId[0].goalTypes
        : null;
    formVars.hedeftipitanim_184070_options = stateVars.sbGoalTypesAll;
    stateVars.sbGoalTypesAll = result?.data.sbGoalTypesAll;
    formVars.hedeftipitanim_184070_value = ReactSystemFunctions.toString(
      this,
      stateVars.msGoalTypesHierarchyByGoalId !== undefined
        ? stateVars.msGoalTypesHierarchyByGoalId?.length > 0
          ? stateVars.msGoalTypesHierarchyByGoalId[0].goalTypes
          : null
        : this.state.msGoalTypesHierarchyByGoalId?.length > 0
        ? this.state.msGoalTypesHierarchyByGoalId[0].goalTypes
        : null
    );

    formVars.hedeftipitanim_184070_value =
      stateVars.msGoalTypesHierarchyByGoalId !== undefined
        ? stateVars.msGoalTypesHierarchyByGoalId?.length > 0
          ? stateVars.msGoalTypesHierarchyByGoalId[0].goalTypes
          : null
        : this.state.msGoalTypesHierarchyByGoalId?.length > 0
        ? this.state.msGoalTypesHierarchyByGoalId[0].goalTypes
        : null;
    formVars.hedeftipitanim_184070_options = stateVars.sbGoalTypesAll;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HedefTipiTanimPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HedefTipiTanimPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.hedeftipitanim_975253_value = ReactSystemFunctions.toString(
      this,
      stateVars.GoalTypesById !== undefined
        ? stateVars.GoalTypesById?.length > 0
          ? stateVars.GoalTypesById[0].name
          : null
        : this.state.GoalTypesById?.length > 0
        ? this.state.GoalTypesById[0].name
        : null
    );

    formVars.hedeftipitanim_184070_value = ReactSystemFunctions.toString(
      this,
      stateVars.msGoalTypesHierarchyByGoalId !== undefined
        ? stateVars.msGoalTypesHierarchyByGoalId?.length > 0
          ? stateVars.msGoalTypesHierarchyByGoalId[0].goalTypes
          : null
        : this.state.msGoalTypesHierarchyByGoalId?.length > 0
        ? this.state.msGoalTypesHierarchyByGoalId[0].goalTypes
        : null
    );

    stateVars.dataSource_184070 =
      stateVars.sbGoalTypesAll ?? this.state.sbGoalTypesAll;
    stateVars.dataSource_184070 =
      stateVars.sbGoalTypesAll ?? this.state.sbGoalTypesAll;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  HedefTipiTanimComponent_657512_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      GoalTypeId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Name_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftipitanim_975253_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      GoalTypesIds_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "hedeftipitanim_184070_value",
            "value",
            "sbGoalTypesAll",
            "id",
            "id"
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "HedefTipiTanim/HedefTipiTanimComponent_657512_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GoalTypesHierarchySave = result?.data.goalTypesHierarchySave;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.HedefTipiTanimComponent_657512_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  HedefTipiTanimComponent_657512_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  HedefTipiTanimComponent_555343_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.HedefTipiTanimPageInit();
    }
  }
}
